import { render, staticRenderFns } from "./_list.vue?vue&type=template&id=674a7dec&scoped=true"
import script from "./_list.vue?vue&type=script&lang=js"
export * from "./_list.vue?vue&type=script&lang=js"
import style0 from "./_list.vue?vue&type=style&index=0&id=674a7dec&prod&scoped=true&lang=css"
import style1 from "./_list.vue?vue&type=style&index=1&id=674a7dec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a7dec",
  null
  
)

export default component.exports